import React from 'react'
import ParkingCard from '@components/ParkingCard/ParkingCard.component'
import { DateTime } from 'luxon'
import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'
import { SpecificCarpayCard } from '../CarpayOrderCard.component'
import CarpayOrderCardHeader from '../CarpayOrderCardHeader.component'
import CarpayOrderCardContent from '../CarpayOrderCardContent.component'
import { CardExtraInfo, FullyWhitelistedCardExtraInfoTitle } from '../CarpayOrderCard.style'

const FullyWhitelistedOrderCard = ({ order, discount, isLast, disabled, currency, onClick }: SpecificCarpayCard) => {
    const startDate = DateTime.fromISO(order.start_date)
    const { t } = useTranslation()
    const [css, theme] = useStyletron()

    return (
        <ParkingCard isLast={isLast} disabled={disabled} onClick={onClick}>
            <CarpayOrderCardHeader text={order.order_id} badgeText="Aktiv" badgeVariant="positive" />

            <CarpayOrderCardContent
                title={t('carpay.orderCard.price')}
                subtitle={`${t('carpay.orderCard.entrance')}: ${startDate.toFormat('dd.MM.yyyy')}`}
                price={0}
                discount={discount}
                currency={currency}
            />

            <div className={css({ display: 'flex', flexDirection: 'column', gap: theme.sizing.scale300 })}>
                <FullyWhitelistedCardExtraInfoTitle>
                    {t('carpay.orderCard.fullyWhitelistedInfo')}
                </FullyWhitelistedCardExtraInfoTitle>
                <CardExtraInfo>{t('carpay.orderCard.fullyWhitelistedInfoSubtitle')}</CardExtraInfo>
            </div>
        </ParkingCard>
    )
}

export default FullyWhitelistedOrderCard
